/**
 * E ITI POints business service
 */
import dayjs from "dayjs";

angular.module("exploitation").factory("ExploitTimetablesService", ["$http", "ENV", function ($http, ENV) {



	/**
     * API
     */
	return {
		editTimetable: editTimetable,
		getTimeTable: getTimeTable,
		getAllTimetables: getAllTimetables,
		addTimetable: addTimetable,
		deleteTimetable: deleteTimetable,
		getTimetableCardColor: getTimetableCardColor,
		refreshTimetables: refreshTimetables,
		getTimetables: getTimetables,
		getProductionPeriods: getProductionPeriods
	};


	/**
     * Mettre à jour un calendrier.
     * @param calendar
     * @returns {*|HttpPromise}
     */
	function editTimetable(calendar) {
		return $http.put(ENV.API_URL + "/timetables/" + calendar.id, calendar);
	}


	/**
     * Récupérer un calendrier par son ID.
     *
     * @param id l'Id du calendrier à récupérer.
     * @returns {*}
     */
	function getTimeTable(id) {
		return $http.get(ENV.API_URL + "/timetables/" + id);
	}

	/**
     * Récupérer des calendriers par leur id.
     * @param timetableIds
     * @returns {*}
     */
	function getTimetables(ids) {
		return $http.get(ENV.API_URL + "/timetables", {
			params: {
				ids,
				paginated: false
			}
		});
	}


	/**
     * Supprimer un calendrier.
     *
     * @param timetable le calendrier à supprimer.
     * @returns {HttpPromise|*|{display}}
     */
	function deleteTimetable(timetable) {
		return $http.delete(ENV.API_URL + "/timetables/" + timetable.id);
	}


	/**
     * Récupérer tous les calendriers (paginé)
     *
     *
     * @returns {*}
     */
	function getAllTimetables(page, sortFields, sortDirections, startDate, endDate, text, filterExpiredTimetables) {
		var params = {
			page: page,
			sortFields: sortFields,
			sortDirections: sortDirections,
			pageSize: 12,
			paginated: true
		};
		if(page === undefined){
        	params.pageSize = 100000;
		}
		if (text) {
			params.text = text;
		}
		if (startDate) {
			params.startDate = dayjs(startDate).format("YYYY-MM-DD");
		}
		if (endDate) {
			params.endDate = dayjs(endDate).format("YYYY-MM-DD");
		}
		if (filterExpiredTimetables) {
			params.filterExpiredTimetables = filterExpiredTimetables;
		}


		return $http.get(ENV.API_URL + "/timetables", {
			params: params
		});
	}

	/**
     * POster un calendrier vers le serveur.
     * @param calendar
     * @returns {*|HttpPromise}
     */
	function addTimetable(calendar) {
		return $http.post(ENV.API_URL + "/timetables", calendar);
	}


	function getTimetableCardColor(endOfPeriod) {

		if (dayjs(endOfPeriod).diff(dayjs()) < 0) {
			// Calendrier écoulé
			return ("-danger");

		} else if (dayjs(endOfPeriod).diff(dayjs().add(1, "month")) < 0) {
			// Calendrier échéance dans moins d'un mois
			return ("-warning");

		} else if (dayjs(endOfPeriod).diff(dayjs()) > 0) {
			return ("-success");

		} else {
			// Pb sur le calcul des dates
			return ("panel-danger");
		}
	}

	function refreshTimetables($scope) {
		getAllTimetables($scope.data.timetables.currentPage,
			"endOfPeriod", "desc",
			$scope.data.search ? $scope.data.search.startDate : undefined,
			$scope.data.search ? $scope.data.search.endDate : undefined,
			$scope.data.search ? $scope.data.search.text : undefined,
			 $scope.data.hideExpiredTimetables
			)
			.then((response) => {
				$scope.data.timetables = response.data;
			});
	}

	/**
	 * Récupérer la période d'activité
	 * @returns {*}
	 */
	function getProductionPeriods() {
		return $http.get(ENV.API_URL + "/timetables/production-periods");
	}


}]);
